<template>
  <component v-if="agent" :is="agent_name" :agent="agent"></component>
</template>

<script>
import Forecasting from "@/components/Agents/Forecasting"
import Agent from "@/api/agents"
export default {
  name: "Agent",
  components: {
    Forecasting,
  },
  data() {
    return {
      agent: null
    }
  },
  computed: {
    agent_name() {
      return `${this.agent.view}`
    }
  },
  created() {
    Agent.retrieve(this.$route.params.slug).then(response => (this.agent = response.data))
  }
}
</script>
